/**
 * Top level path the Automation Agents area is mounted at. Kept apart from the routing module so
 * other areas can link here without pulling the route definitions in with them.
 */
export const automationAgentsRoutePath: string = 'Agents';

/** Segment under {@link automationAgentsRoutePath} that opens a single agent's dashboard */
export const agentRoutePath: string = 'agent';

/** Sections of one agent's dashboard, matching the left hand nav */
export enum AgentRouteSectionEnum {
    dashboard = 'DASHBOARD',
    mentions = 'MENTIONS',
    analytics = 'ANALYTICS'
}

/** Path segment each section is mounted at, kept lower case as the rest of the app's routes are */
export const agentSectionSegments: Record<AgentRouteSectionEnum, string> = {
    [AgentRouteSectionEnum.dashboard]: 'dashboard',
    [AgentRouteSectionEnum.mentions]: 'mentions',
    [AgentRouteSectionEnum.analytics]: 'analytics'
};

/** Absolute route for one agent's section, used by the card and the sidebar alike */
export function agentSectionRoute(agentId: number, section: AgentRouteSectionEnum): string {
    return `/${automationAgentsRoutePath}/${agentRoutePath}/${agentId}/${agentSectionSegments[section]}`;
}
